import type { IconSvgObject } from './types';

const FiveCircleIcon: IconSvgObject = [
  ["path", { d: "M9 15C9 15 9.5 17 12 17C13.6569 17 15 15.7949 15 14C15 12.2051 13.6569 11 12 11C10.3431 11 9 12 9 12L10 7H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FiveCircleIcon;
